import React from "react";
import { MdNote } from "react-icons/md";
import { Order } from "../utils/type";

interface Props {
  order: Order;
  setOrder: React.Dispatch<React.SetStateAction<Order>>;
}

const OrderNote = ({ order, setOrder }: Props) => {
  return (
    <div className="bg-white rounded-2xl p-6 shadow-lg">
      <div className="flex items-center space-x-3 mb-4">
        <div className="p-2.5 bg-purple-100 rounded-xl">
          <MdNote className="text-purple-600 w-4 h-4" />
        </div>
        <h2 className="text-md font-bold text-gray-800">訂單備注</h2>
      </div>
      <textarea
        value={order.note}
        onChange={(e) =>
          setOrder((prev) => ({ ...prev, note: e.target.value }))
        }
        className="w-full p-3.5 border-2 border-gray-200 rounded-xl focus:ring-2 focus:ring-purple-500 focus:border-purple-500 transition-all resize-none"
        rows={4}
        placeholder="請輸入訂單備注（選填）"
      />
    </div>
  );
};

export default OrderNote;

